import React from 'react';
import PropTypes from 'prop-types';
import withLocale from 'jsx/locale/withLocale';

const MainContent = ({ minHeight, children }) => {
  return (
    <main className="main transition" role="main" style={{ minHeight: minHeight + 'px' }}>
      {children}
    </main>
  );
};

MainContent.propTypes = {
  minHeight: PropTypes.number,
  children: PropTypes.node
};

export default withLocale(MainContent);



// WEBPACK FOOTER //
// ./src/common/jsx/layout/MainContent.js